import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

import { createVuetify, ThemeDefinition } from 'vuetify';
import {VDataTable, VDataTableServer, VDataTableFooter} from "vuetify/labs/VDataTable";

const lightPusic: ThemeDefinition = {
    dark: false,
    colors: {
        background: '#f5f5f5',
        surface: '#ffffff',
        primary: '#80d6e3',
        'primary-darken-1': '#61adbb',
        secondary: '#348E8F',
        'secondary-darken-1': '#2c7677',
        error: '#B00020',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
    },
}

const darkPusic: ThemeDefinition = {
    dark: true,
    colors: {
        background: '#2d333c',
        surface: '#22272e',
        primary: '#80d6e3',
        'primary-darken-1': '#61adbb',
        secondary: '#348E8F',
        'secondary-darken-1': '#2c7677',
        error: '#B00020',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
    }
}

const lightYourVirals: ThemeDefinition = {
    ...lightPusic,
    ...{
        colors: {
            ...lightPusic.colors,
            ...{
                primary: '#EA473D',
                'primary-darken-1': '#ab362f',
                secondary: '#140000',
                'secondary-darken-1': '#312929',
            }
        }
    }
}

const darkYourVirals: ThemeDefinition = {
    ...darkPusic,
    ...{
        colors: {
            ...darkPusic.colors,
            ...{
                primary: '#EA473D',
                'primary-darken-1': '#d03f36',
                secondary: '#F2EFED',
                'secondary-darken-1': '#c7c4c3',
            }
        }
    }
}

const prefersDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

export default createVuetify({
    components: {
        VDataTable,
        VDataTableServer,
        VDataTableFooter,
    },
    theme: {
        defaultTheme: (prefersDarkMode ? 'dark' : 'light') + window.global.theme,
        themes: {
            lightPusic: lightPusic,
            darkPusic: darkPusic,
            lightYourVirals: lightYourVirals,
            darkYourVirals: darkYourVirals,
        },
    },
});
